import { Routes } from '@angular/router';
import { RoleEmpGuard } from '../services/roleEmp-guard.service';

//Route for content layout without sidebar, navbar and footer for pages like Login, Registration etc...
export const empPages_Routes: Routes = [
    {
        path: '',
        canActivate: [RoleEmpGuard],
        loadChildren: () => import('../../empPages/emp-home/emp-home.module').then(m => m.EmpHomeModule)
    },
    {
        path: 'employee-home',
        canActivate: [RoleEmpGuard],
        data: { role: 'employee-home'},
        loadChildren: () => import('../../empPages/emp-home/emp-home.module').then(m => m.EmpHomeModule)
    },
    {
        path: 'employee-vacancies',
        canActivate: [RoleEmpGuard],
        data: { role: 'employee-vacancies'},
        loadChildren: () => import('../../empPages/emp-vacancies/emp-vacancies.module').then(m => m.EmpVacanciesModule)
    },
    {
        path: 'employee-objetives',
        canActivate: [RoleEmpGuard],
        data: { role: 'employee-objetives'},
        loadChildren: () => import('../../empPages/emp-objetives/emp-objetives.module').then(m => m.EmpObjetivesModule)
    },
    {
        path: 'employee-reviews',
        canActivate: [RoleEmpGuard],
        data: { role: 'employee-reviews'},
        loadChildren: () => import('../../empPages/emp-reviews/emp-reviews.module').then(m => m.EmpReviewsModule)
    },
    {
        path: 'employee-checker',
        canActivate: [RoleEmpGuard],
        data: { role: 'employee-checker'},
        loadChildren: () => import('../../empPages/emp-checker/emp-checker.module').then(m => m.EmpCheckerModule)
    },
    {
        path: 'employee-objetives-results',
        canActivate: [RoleEmpGuard],
        data: { role: 'employee-objetives-results'},
        loadChildren: () => import('../../empPages/emp-performance-results/emp-performance-results.module').then(m => m.EmpPerformanceResultsModule)
    }
]